<template>
  <div>
     <div v-if="ShowBox" style="width: 100vw; height: 100vh; background: rgba(0, 0, 0, 0.8); position: fixed; z-index: 99999">
      <img style="width: 100%; height: 100%" src="./assets/images/bg_01.png" />
    </div>
      <div id="app">
      <!-- 公共头部 -->
      <global-header />
      <router-view />
    </div>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import globalHeader from './views/component/header.vue'
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    globalHeader
  },
  data() {
    // 这里存放数据
    return {
      ShowBox:false,
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
     // 判断是否是微信
    isWeiXin() {
      var ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        this.ShowBox = true;
      } else {
        this.ShowBox = false;
      }
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.isWeiXin()
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less">
/* //@import url(); 引入公共css类 */

</style>
